import { FC } from "react";

interface ITabItemProps {
  currentContent: number;
  onSetContent: (content: number) => void;
  tabContent: number;
  tabLabel: string;
}

const TabItem: FC<ITabItemProps> = ({
  currentContent,
  onSetContent,
  tabContent,
  tabLabel,
}) => {
  return (
    <li className={'' + (
      currentContent === tabContent
        ? ' active'
        : ''
    )}>
      <a
        className="btn-item"
        onClick={() => onSetContent(tabContent)}
      >
        {tabLabel}
      </a>
    </li>
  );
}

export default TabItem;
